import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export default function LoadingSpinner() {
    return(
        <Box display="flex" justifyContent="center" alignItems="center" p={2}>
            <CircularProgress size={24} />
        </Box>
    );
}